import { render, staticRenderFns } from "./buy-history.vue?vue&type=template&id=3cde6909&scoped=true"
import script from "./buy-history.vue?vue&type=script&lang=ts"
export * from "./buy-history.vue?vue&type=script&lang=ts"
import style0 from "./buy-history.vue?vue&type=style&index=0&id=3cde6909&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cde6909",
  null
  
)

export default component.exports